/* assets/ps-cart-advisor.js */
(function() {
  'use strict';
  
  window.PS = window.PS || {};

  // ============================================================
  // 1. CONFIGURATION
  // ============================================================
  var DEFAULT_UPSELL_COLLECTION = 'cart-upsells';
  var DEFAULT_UPSELL_TITLE = 'You\'ll Also Need...';
  var DEFAULT_UPSELL_DESCRIPTION = 'Essential add-ons to ensure a perfect repair.';

  // ============================================================
  // 2. STYLES (Upsells Only)
  // ============================================================
  var CSS = [
    '/* Upsell Blue Box Area (Color-Product Style) */',
    '.ps-upsell-wrapper {',
    '  margin-top: 40px;',
    '  padding: 30px;',
    '  background-color: #dae5ed; /* Light Blue-Grey */',
    '  border-radius: 4px;',
    '  color: #333;',
    '}',
    '.ps-upsell-head h2 {',
    '  font-family: serif;',
    '  font-size: 28px;',
    '  margin: 0 0 5px 0;',
    '  color: #1c2b39;',
    '}',
    '.ps-upsell-head p {',
    '  margin: 0 0 25px 0;',
    '  color: #566b7c;',
    '  font-size: 15px;',
    '}',
    '.ps-upsell-grid {',
    '  display: grid;',
    '  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));',
    '  gap: 15px;',
    '}',
    '/* Upsell Cards (White, Clean, Left Aligned) */',
    '.ps-std-card {',
    '  background: #fff;',
    '  border: 1px solid #fff;',
    '  border-radius: 3px;',
    '  padding: 15px;',
    '  display: flex;',
    '  flex-direction: column;',
    '  text-align: left;',
    '  transition: box-shadow 0.2s ease;',
    '  box-shadow: 0 2px 5px rgba(0,0,0,0.05);',
    '}',
    '.ps-std-card:hover {',
    '  box-shadow: 0 5px 15px rgba(0,0,0,0.1);',
    '}',
    '.ps-std-card img {',
    '  width: 100%;',
    '  height: 160px;',
    '  object-fit: contain;',
    '  margin-bottom: 12px;',
    '  display: block;',
    '}',
    '.ps-std-card .title-link {',
    '  font-family: serif;',
    '  font-size: 15px;',
    '  font-weight: 600;',
    '  color: #1c2b39;',
    '  text-decoration: none;',
    '  line-height: 1.35;',
    '  margin-bottom: 4px;',
    '  display: block;',
    '}',
    '.ps-std-card .title-link:hover {',
    '  text-decoration: underline;',
    '}',
    '.ps-std-card .price {',
    '  font-size: 15px;',
    '  font-weight: 400;',
    '  color: #333;',
    '  margin-bottom: 8px;',
    '}',
    '.ps-std-card .desc {',
    '  font-size: 13px;',
    '  color: #666;',
    '  line-height: 1.4;',
    '  margin-bottom: 15px;',
    '  flex-grow: 1;',
    '  display: -webkit-box;',
    '  -webkit-line-clamp: 3;',
    '  -webkit-box-orient: vertical;',
    '  overflow: hidden;',
    '}',
    '/* Full Width Button */',
    '.ps-std-card .ps-btn-add {',
    '  width: 100%;',
    '  display: block;',
    '  background-color: #ffffff;',
    '  color: #555555;',
    '  border: 1px solid #cccccc;',
    '  padding: 10px 0;',
    '  text-align: center;',
    '  font-weight: 400;',
    '  font-size: 14px;',
    '  cursor: pointer;',
    '  border-radius: 3px;',
    '  transition: all 0.2s;',
    '}',
    '.ps-std-card .ps-btn-add:hover {',
    '  background-color: #f4f4f4;',
    '  border-color: #999999;',
    '  color: #333333;',
    '}'
  ].join('\n');

  // ============================================================
  // 3. HELPERS
  // ============================================================

  function injectStyles() {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = CSS;
    document.head.appendChild(style);
  }

  function request(method, url, data, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400 && onSuccess) {
        try { onSuccess(JSON.parse(xhr.responseText)); } catch (e) { if (onError) onError(e); }
      } else if (onError) onError(xhr.status);
    };
    xhr.onerror = function() { if (onError) onError('Network Error'); };
    xhr.send(data ? JSON.stringify(data) : null);
  }

  function getUpsellConfig(container) {
    var handle;
    var title;
    var description;

    if (!container) {
      return {
        handle: DEFAULT_UPSELL_COLLECTION,
        title: DEFAULT_UPSELL_TITLE,
        description: DEFAULT_UPSELL_DESCRIPTION
      };
    }

    handle = container.getAttribute('data-upsell-collection') || '';
    title = container.getAttribute('data-upsell-title') || '';
    description = container.getAttribute('data-upsell-description') || '';

    return {
      handle: normalizeCollectionHandle(handle) || DEFAULT_UPSELL_COLLECTION,
      title: title || DEFAULT_UPSELL_TITLE,
      description: description || DEFAULT_UPSELL_DESCRIPTION
    };
  }

  function normalizeCollectionHandle(value) {
    var handle = (value || '').toString();
    handle = handle.replace(/^https?:\/\/[^/]+/i, '');
    handle = handle.replace(/\?.*$/, '');
    handle = handle.replace(/#.*$/, '');
    handle = handle.replace(/^\/+/, '');
    if (handle.indexOf('collections/') === 0) {
      handle = handle.substring('collections/'.length);
    }
    handle = handle.replace(/^\/+/, '');
    handle = handle.replace(/\/+$/, '');
    return handle;
  }

  function findShopifySection(node) {
    var current = node;
    while (current && current !== document.body) {
      if (current.id && current.id.indexOf('shopify-section-') === 0) {
        return current;
      }
      current = current.parentNode;
    }
    return node;
  }

  // ============================================================
  // 4. MAIN LOGIC
  // ============================================================

  window.PS.Advisor = {
    init: function() {
      injectStyles();
      request('GET', '/cart.js', null, function(cart) {
        window.PS.Advisor.analyze(cart);
      });
    },

    analyze: function(cart) {
      var items = cart.items;
      var inv = { hasPaint: false, hasClear: false, hasPrimer: false, handles: [] };

      // 1. Scan Inventory
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var h = item.handle;
        inv.handles.push(h);

        // Heuristic: Check for paint
        var isPaint = (h.indexOf('paint') > -1 && h.indexOf('clear') === -1 && h.indexOf('primer') === -1);
        if (item.properties && (item.properties['Color Code'] || item.properties['Color Code'])) isPaint = true;
        
        if (isPaint) inv.hasPaint = true;
        if (h.indexOf('clear') > -1 || item.product_type === 'Clearcoat') inv.hasClear = true;
        if (h.indexOf('primer') > -1 || item.product_type === 'Primer') inv.hasPrimer = true;
      }

      var upsellContainer = document.getElementById('ps-cart-upsells');

      // 3. Setup Bottom Upsells
      if (upsellContainer && inv.hasPaint) {
        upsellContainer.innerHTML = '';
        window.PS.Advisor.checkUpsells(inv, upsellContainer);
      }
    },

    checkUpsells: function(inv, container) {
      var attemptedFallback = false;
      var upsellConfig = getUpsellConfig(container);

      function loadUpsellCollection(handle) {
        request('GET', '/collections/' + handle + '/products.json?limit=24', null, function(data) {
          if ((!data || !data.products) && !attemptedFallback && handle !== DEFAULT_UPSELL_COLLECTION) {
            attemptedFallback = true;
            loadUpsellCollection(DEFAULT_UPSELL_COLLECTION);
            return;
          }

        if (!data.products) return;

        var displayList = [];
        for (var i = 0; i < data.products.length; i++) {
          var p = data.products[i];
          if (inv.handles.indexOf(p.handle) === -1) displayList.push(p);
          if (displayList.length >= 8) break; // Limit to 8 for clean grid
        }

        if (displayList.length > 0) {
          var html = '<div class="ps-upsell-wrapper">';
          html += '<div class="ps-upsell-head">';
          html += '<h2>' + upsellConfig.title + '</h2>';
          html += '<p>' + upsellConfig.description + '</p>';
          html += '</div>';
          
          html += '<div class="ps-upsell-grid">';
          for (var j = 0; j < displayList.length; j++) {
            html += window.PS.Advisor.buildStandardCard(displayList[j]);
          }
          html += '</div></div>';
          
          container.innerHTML = html;
          container.style.display = 'block';

          // RELOCATION LOGIC: Move upsells below checkout footer and cart guarantees
          setTimeout(function() {
            var footer = document.querySelector('#main-cart-footer') || document.querySelector('.cart__footer');
            var footerSection = footer ? findShopifySection(footer) : null;
            var insertAfter = footerSection || footer;
            var nextSection = footerSection ? footerSection.nextElementSibling : null;
            if (
              nextSection &&
              nextSection.textContent &&
              nextSection.textContent.indexOf('Why millions of car owners trust PaintScratch') !== -1
            ) {
              insertAfter = nextSection;
            }
            if (insertAfter && insertAfter.parentNode && container.previousElementSibling !== insertAfter) {
              insertAfter.parentNode.insertBefore(container, insertAfter.nextSibling);
            }
          }, 50);
        }
        }, function() {
          if (!attemptedFallback && handle !== DEFAULT_UPSELL_COLLECTION) {
            attemptedFallback = true;
            loadUpsellCollection(DEFAULT_UPSELL_COLLECTION);
          }
        });
      }

      loadUpsellCollection(upsellConfig.handle);
    },

    // ============================================================
    // 5. HTML BUILDERS
    // ============================================================

    buildStandardCard: function(p) {
      var img = p.images.length > 0 ? p.images[0].src : '';
      var variantId = p.variants[0].id; 
      var price = p.variants[0].price;
      
      // Simple description stripping: remove HTML tags, limit chars
      var desc = p.body_html || '';
      desc = desc.replace(/<[^>]+>/g, '');
      if (desc.length > 90) desc = desc.substring(0, 90) + '...';

      var html = '<div class="ps-std-card">';
      
      // Image
      html += '<a href="/products/' + p.handle + '">';
      if(img) html += '<img src="' + img + '" alt="' + p.title + '">';
      html += '</a>';

      // Title
      html += '<a href="/products/' + p.handle + '" class="title-link">' + p.title + '</a>';
      
      // Price (assuming USD)
      html += '<div class="price">$' + price + '</div>';

      // Description
      html += '<div class="desc">' + desc + '</div>';
      
      // Button
      html += '<button type="button" class="ps-btn-add ps-advisor-add-variant" data-variant-id="' + variantId + '">Add to cart</button>';
      
      html += '</div>';
      return html;
    },

    addToCartVariant: function(variantId, btn) {
      var payload = { items: [{ id: variantId, quantity: 1 }] };
      request('POST', '/cart/add.js', payload, function() {
        window.location.reload();
      }, function() {
        if(btn) btn.innerHTML = 'Error';
      });
    }
  };

  // ============================================================
  // 6. INITIALIZATION
  // ============================================================

  var advisorAnalyzeStarted = false;
  var advisorButtonsBound = false;

  function hasClassToken(node, token) {
    var className;
    if (!node || node.nodeType !== 1) return false;
    className = typeof node.className === 'string'
      ? node.className
      : (node.className && typeof node.className.baseVal === 'string' ? node.className.baseVal : '');
    return (' ' + className + ' ').indexOf(' ' + token + ' ') > -1;
  }

  function findAdvisorButton(target) {
    var node = target;
    while (node && node !== document) {
      if (hasClassToken(node, 'ps-advisor-add-variant')) return node;
      node = node.parentNode;
    }
    return null;
  }

  function bindAdvisorButtons() {
    if (advisorButtonsBound) return;
    advisorButtonsBound = true;
    document.addEventListener('click', function(e) {
      var btn;
      var varId;
      if (!e.target) return;
      btn = findAdvisorButton(e.target);
      if (btn) {
        e.preventDefault();
        varId = btn.getAttribute('data-variant-id');
        if (varId) {
          btn.innerHTML = '...';
          window.PS.Advisor.addToCartVariant(varId, btn);
        }
      }
    });
  }

  function runAdvisorAnalyze() {
    if (advisorAnalyzeStarted) return;
    advisorAnalyzeStarted = true;
    window.PS.Advisor.init();
  }

  function scheduleAnalyze() {
    function scheduleAfterLoad() {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(function() {
          runAdvisorAnalyze();
        }, { timeout: 2500 });
      } else {
        setTimeout(runAdvisorAnalyze, 900);
      }
    }

    if (advisorAnalyzeStarted) return;
    if (document.readyState === 'complete') {
      scheduleAfterLoad();
    } else if (window.addEventListener) {
      window.addEventListener('load', scheduleAfterLoad, false);
    } else {
      setTimeout(runAdvisorAnalyze, 2500);
    }
  }

  function init() {
    bindAdvisorButtons();
    scheduleAnalyze();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
